import { TCommandInfo, TDialogElement, TIdInfo } from 'components/Projects/ProjectAILARP';
import { action, makeObservable, observable } from 'mobx';
import i18n from 'locales/i18n';
import BaseStore from './BaseStore';
import { RootStore } from './RootStore';

export type TActionInfo = {
  id: number;
  description: string;
  name: string;
  title: string;
  persons: string;
  group: string;
  groupId?: number;
};

class PrototypeActionStore extends BaseStore {
  _ids!: number;
  constructor(rootStore: RootStore) {
    super(rootStore, {
      parseCommands: action,
    });
    this._ids = 0;
    makeObservable(this, {
      _ids: observable,
    });
  }
  get data(): TActionInfo[] {
    return this._data as TActionInfo[];
  }

  get ids() {
    this._ids += 1;
    return this._ids;
  }

  parseCommands(commands: TCommandInfo[], newDialog: TDialogElement[]) {
    if (!commands?.length) return;
    commands.forEach((command: TCommandInfo) => {
      if (!command?.command) return;
      switch (command.command) {
        case 'action_add':
          this.add({ ...command.data, id: this.ids } as TActionInfo);
          newDialog.push({
            text: i18n.t('projectLARPAI.actionAdd') + (command.data as TActionInfo).name,
            source: 'system',
          });
          break;
        case 'action_remove':
          if (command.id) {
            if (Number.isNaN(+command.id)) return;
            const { name } = this.get(+command.id);
            this.remove(+command.id);
            newDialog.push({ text: i18n.t('projectLARPAI.actionDelete') + name, source: 'system' });
          }
          break;
        case 'action_edit':
          {
            const { id = 0, data } = command;
            if (Number.isNaN(+id)) return;
            if (id !== undefined && id > -1) {
              this.update({ ...data, id: +id });
              newDialog.push({
                text: i18n.t('projectLARPAI.actionEdit') + this.get(+id).name,
                source: 'system',
              });
            }
          }
          break;
        default:
          break;
      }
    });
  }

  sendToAI(commands: TCommandInfo[]) {
    this._data.forEach((el: TActionInfo) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data: any = { ...el };
      delete data.id;
      commands.push({
        command: 'action_add',
        id: el.id,
        data,
      });
    });
  }
  getIds(): TIdInfo {
    const list: TIdInfo = {};
    this._data.forEach((el: TActionInfo) => {
      list[el.name] = el.id;
    });
    return list;
  }
}
export default PrototypeActionStore;
